export default __webpack_public_path__ + "static/media/tl.f85982bd.png";